module.exports = __webpack_public_path__ + "img/blue-person-icon.dbe01cb7.svg";